const DEFAULT_OPENING_HOURS = {
  zone: 'Europe/London',
  openingHours: {
    0: {},
    1: { open: '8', close: '20' },
    2: { open: '8', close: '20' },
    3: { open: '8', close: '20' },
    4: { open: '8', close: '20' },
    5: { open: '8', close: '20' },
    6: { open: '8', close: '14' },
  },
  closedOn: {
    0: [1],
    1: [],
    2: [],
    3: [],
    4: [],
    5: [],
    6: [],
    7: [],
    8: [],
    9: [],
    10: [],
    11: [25],
  },
};

export const { zone, openingHours, closedOn } =
  window.utag_data?.chat_opening_hours ?? DEFAULT_OPENING_HOURS;

export const isDateHoliday = (date) =>
  date.getDay() === 0 || closedOn[date.getMonth()].includes(date.getDate());

export const getTodaysOpeningHours = (today) => {
  const { open, close } = openingHours[today.getDay()] || {};

  const openHours = new Date(today).setHours(open, 0, 0, 0);
  const closeHours = new Date(today).setHours(close, 0, 0, 0);

  return [openHours, closeHours];
};
